import React, { ComponentProps } from 'react'
import { Platform, TextInput, TextInputProps } from 'react-native'

import { styled } from 'nativewind'

import { Stack, XStack } from '../layout'
import { colors } from '../tailwind'

const inputFrameDefaultClass =
  'rounded-r  font-[Graphie-Book] text-sm leading-5 bg-neutral[white100]'
const InputGroupFrame = styled(
  XStack,
  'flex-row border bg-neutral[white100] rounded focus:border-primary-100 overflow-hidden',
  {
    variants: {
      type: {
        primary: 'border-grays-40 focus:border-primary-100',
        success: 'border-success-100 focus:border-primary-100',
        error: 'border-error-100 focus:border-primary-100',
        warning: 'border-warning-100 focus:border-primary-100',
        disabled: 'border-grays-20 bg-grays-5',
      },
    },
    defaultProps: {
      type: 'primary',
    },
  }
)

const Seperator = styled(Stack, 'bg-grays-40 w-px')
const Input = styled(
  TextInput,
  `${inputFrameDefaultClass} w-full rounded-r-md pl-2`,
  {
    variants: {
      size: {
        md: 'px-2',
        lg: 'py-4/2',
      },
    },
    defaultProps: {
      size: 'lg',
    },
  }
)

type InputGroupFrameProps = ComponentProps<typeof InputGroupFrame>

type InputGroupProps = InputGroupFrameProps &
  TextInputProps & {
    defaultText?: string
    defaultTextStyle?: string
  }

export const InputGroup = React.forwardRef(
  (
    {
      defaultText = '+91',
      type,
      size,
      defaultTextStyle,
      ...props
    }: InputGroupProps,
    ref
  ) => {
    return (
      <InputGroupFrame type={type} size={size}>
        <Input
          className={` bg-neutral-white100 py-4/2 w-7 rounded-l-md p-2 font-[Graphie-Book] ${defaultTextStyle} `}
          style={{ width: Platform.OS === 'web' ? 56 : 48 }}
          editable={false}
          defaultValue={defaultText}
        />
        <Seperator />
        <Input
          ref={ref}
          selectionColor={'#070707A8'}
          {...props}
          size={size}
          placeholderTextColor={colors.grays[50]}
        />
      </InputGroupFrame>
    )
  }
)
